
import { Env, EnvConfig } from 'apprise-frontend-core/env'
import { TogglePolicy } from 'apprise-frontend-core/toggle/context'
import { PropsWithChildren } from 'react'


// a base application template: mounts common providers aggregating their configuration.

export const Application = (props: PropsWithChildren<Partial<{

    env: Partial<EnvConfig>

}>>) => {

    const { children, env } = props

    if (env?.version)
        console.log(`starting version: ${env.version}`)

    return <Env {...env} >
        <TogglePolicy>
                {children}
        </TogglePolicy>
    </Env >
}